import { CalendarPlus } from "lucide-react";
import { googleCalendarUrl, icsUrl, outlookCalendarUrl } from "../lib/calendar";

const linkCls =
  "flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-3 text-sm font-semibold text-slate-800 transition-[background-color,border-color] duration-200 hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800";

export const CalendarActions = ({ event }) => (
  <div data-testid="calendar-actions" className="mt-6 rounded-2xl bg-slate-50 p-4">
    <p className="mb-3 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-700">
      <CalendarPlus className="h-4 w-4" /> Add to your calendar
    </p>
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
      <a data-testid="calendar-google-btn" className={linkCls} href={googleCalendarUrl(event)} target="_blank" rel="noopener noreferrer">
        Google
      </a>
      <a data-testid="calendar-outlook-btn" className={linkCls} href={outlookCalendarUrl(event)} target="_blank" rel="noopener noreferrer">
        Outlook
      </a>
      <a data-testid="calendar-ical-btn" className={linkCls} href={icsUrl(event.slug)} download={`${event.slug}.ics`}>
        Apple / iCal
      </a>
    </div>
  </div>
);
